export default __webpack_public_path__ + "static/media/wood_wood_bg.146b903d.png";